import { useAtomValue } from "jotai";
import { Navigate } from "react-router-dom";

import { FALLBACK_HOME_PATH, getDefaultHomePath } from "@/routes/menuConfig";
import { menusAtom } from "@/store/auth";

interface DynamicParentRedirectProps {
  /** 父级菜单 href，如 /settings */
  parentHref: string;
}

/**
 * 父级菜单无独立页面时，按用户菜单树重定向到第一个子菜单
 * @param parentHref 父级路径
 */
export const DynamicParentRedirect = ({ parentHref }: DynamicParentRedirectProps) => {
  const menus = useAtomValue(menusAtom);
  const parent = menus.find((item) => item.href === parentHref);
  const target =
    parent?.children?.[0]?.href ??
    (menus.length > 0 ? getDefaultHomePath(menus) : FALLBACK_HOME_PATH);
  return <Navigate to={target} replace />;
};
